import { render, staticRenderFns } from "./AgentPermissions.vue?vue&type=template&id=7fc740a1&scoped=true&"
import script from "./AgentPermissions.vue?vue&type=script&lang=js&"
export * from "./AgentPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc740a1",
  null
  
)

export default component.exports